import { projectTypeName } from '../../../common/constants'
import { CsvColumn } from '../reportCsvExport'
import { ManHoursReportProject } from './manHoursReportApi'

// The same columns and formatting as the Labor Metrics table.
export const manHoursExportColumns: CsvColumn<ManHoursReportProject>[] = [
  {
    title: 'Job Name',
    dataIndex: 'jobName',
  },
  {
    title: 'Work Area',
    dataIndex: 'projectWorkareaName',
  },
  {
    title: 'Job Type',
    dataIndex: 'jobType',
    render: (_, record) => projectTypeName(record.jobType)
  },
  {
    title: 'Customer',
    dataIndex: 'displayName',
  },
  {
    title: 'Address',
    render: (_, record) => `${record.address1} ${record.city}, ${record.state} ${record.zip}`
  },
  {
    title: 'Sales Person',
    dataIndex: 'salesPersonName',
  },
  {
    title: 'Division',
    render: (_, record) => record.divisionName
  },
  {
    title: 'Estimated Man Hours',
    dataIndex: 'estimatedManHours',
  },
  {
    title: 'Actual Man Hours',
    dataIndex: 'actualManHours',
  }
]
